import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'

export const renderAdjRow = (item) => {
  const { ref_document, short_index_name, ...rest } = item || {}
  if (_.isEmpty(ref_document)) {
    return (
      <Translate>
        {(t) => (
          <span className="font-light text-sm text-color-400 italic">{t('no data')}</span>
        )}
      </Translate>
    )
  }
  return <Translate>{(t) => <div className="p-3">????????????</div>}</Translate>
}
